import React from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';

import styles from './AdSection.module.scss';
import './slick.scss'; // react-slick stylings

//React-Slick Settings
const slickSettings = {
  dots: true,
  className: styles.carouselContent,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  variableWidth: true,
  focusOnSelect: true,
  arrows: true
};

const {
  'ad-section-wrapper': adSectionClass,
  subtitle: subtitleClass,
  'ad-card': adCardClass,
  'ad-image': adImageClass,
  'ad-title': adTitleClass,
  'ad-subtitle': adSubtitleClass,
  'ad-button': adButtonClass
} = styles;

const Ad = ({
  imageUrl,
  title: adTitle,
  subtitle: adSubtitle,
  _id,
  ctaText,
  ctaUrl,
  adId,
  trackAds,
  memorialId
}) => {
  const dispatch = useDispatch();

  return (
    <div className={adCardClass}>
      {!!imageUrl && (
        <div style={{ backgroundImage: `url(${imageUrl})` }} className={adImageClass} />
      )}
      {!!adTitle && <div className={adTitleClass}>{adTitle}</div>}
      {!!adSubtitle && <div className={adSubtitleClass}>{adSubtitle}</div>}
      {!!ctaText && (
        <a
          href={ctaUrl}
          onClick={() => dispatch(trackAds({ adId, memorialId }))}
          className={adButtonClass}
          target="_blank"
          rel="noreferrer"
        >
          <span>{ctaText}</span>
        </a>
      )}
    </div>
  );
};

const AdSection = ({ adData, trackAds = () => {}, memorialId }) => {
  const { background = {}, ads = [] } = adData || {};
  const { subtitle } = background || {};

  return (
    <div className={adSectionClass}>
      {!!ads.length && (
        <Slider {...slickSettings}>
          {ads.map(ad => (
            <Ad key={ad._id} {...{ ...ad, trackAds, memorialId }} />
          ))}
        </Slider>
      )}
    </div>
  );
};

export default AdSection;
